var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10018_24488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0441 10.7444C16.8126 12.9193 15.5803 14.9574 13.5411 16.1347C10.1532 18.0907 5.82114 16.9299 3.86513 13.542L3.6568 13.1812M2.95509 9.25602C3.18659 7.08111 4.41891 5.043 6.45807 3.8657C9.84598 1.90969 14.1781 3.07047 16.1341 6.45838L16.3424 6.81922M2.91095 15.0552L3.52099 12.7785L5.7977 13.3886M14.202 6.61186L16.4787 7.2219L17.0887 4.94519",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10018_24488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh2);
export default __webpack_public_path__ + "static/media/refresh2.78f3ce870acf20d123234ff501d49abd.svg";
export { ForwardRef as ReactComponent };